import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useQzTray } from '../context/QzTrayContext';
import WorkstationPrinterModal from './WorkstationPrinterModal';
import './PillNavigation.css';

const PillNavigation = () => {
  const { currentUser, logout, canAccessPage, canPerformAction, isImpersonating } = useAuth();
  const qz = useQzTray() || {};
  const { connected: qzConnected, config: qzConfig } = qz;
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isPrinterModalOpen, setIsPrinterModalOpen] = useState(false);
  const showStockHouse = canAccessPage('stockHouse') || canAccessPage('orders');
  const canSetupPrinter = canPerformAction('inventory.workstationPrinter') || canPerformAction('admin.printJobs') || canAccessPage('admin');

  const handleLogout = async () => {
    try {
      await logout();
      // The router will automatically redirect to the login page.
    } catch (error) {
      console.error("Failed to log out", error);
    }
  };

  if (!currentUser) {
    return null; // Don't render anything if there's no user
  }

  const closeDrawer = () => setIsMobileOpen(false);
  const navLinkClass = ({ isActive }) => (isActive ? 'active' : '');

  return (
    <>
      <nav className="pill-navigation">
        <button className="pill-hamburger" aria-label="Open navigation" onClick={() => setIsMobileOpen(true)}>
          <span /><span /><span />
        </button>
        <div className={`pill-nav-overlay ${isMobileOpen ? 'visible' : ''}`} onClick={closeDrawer} />
        <div className={`pill-nav ${isMobileOpen ? 'open' : ''}`}>
          <button className="pill-close" aria-label="Close navigation" onClick={closeDrawer}>&times;</button>
          {canAccessPage('admin') && <NavLink to="/" className={navLinkClass} onClick={closeDrawer}>Dashboard</NavLink>}
          {(canAccessPage('fulfillment') || canAccessPage('admin')) && <NavLink to="/fulfillment" className={navLinkClass} onClick={closeDrawer}>📦 Fulfillment</NavLink>}
          {(canAccessPage('ordersNew') || canAccessPage('admin')) && <NavLink to="/new-orders" className={navLinkClass} onClick={closeDrawer}>Orders</NavLink>}
          {(canAccessPage('v9ActionQueue') || canAccessPage('admin')) && <NavLink to="/v9-action-queue" className={navLinkClass} onClick={closeDrawer}>Action Queue</NavLink>}
          {showStockHouse && <NavLink to="/stock-house" className={navLinkClass} onClick={closeDrawer}>Stock House</NavLink>}
          {(canAccessPage('offers') || canAccessPage('admin')) && <NavLink to="/offers" className={navLinkClass} onClick={closeDrawer}>Offers</NavLink>}
          {canAccessPage('inventory') && <NavLink to="/inventory" className={navLinkClass} onClick={closeDrawer}>Inventory</NavLink>}
          {canAccessPage('batches') && <NavLink to="/batches" className={navLinkClass} onClick={closeDrawer}>Production</NavLink>}
          {canAccessPage('products') && <NavLink to="/products" className={navLinkClass} onClick={closeDrawer}>Products</NavLink>}
          {canAccessPage('admin') && <NavLink to="/collections-automation" className={navLinkClass} onClick={closeDrawer}>Collections</NavLink>}
          {(canAccessPage('bundles') || canAccessPage('inventory')) && <NavLink to="/bundles" className={navLinkClass} onClick={closeDrawer}>Bundles</NavLink>}
          {(canAccessPage('orderDesk') || canAccessPage('admin')) && <NavLink to="/order-desk" className={navLinkClass} onClick={closeDrawer}>Order Desk</NavLink>}
          {canAccessPage('support') && <NavLink to="/support" className={navLinkClass} onClick={closeDrawer}>Support</NavLink>}
          {(canAccessPage('b2bExport') || canAccessPage('admin')) && <NavLink to="/b2b-export" className={navLinkClass} onClick={closeDrawer}>🌍 B2B Export</NavLink>}
          {(canAccessPage('lookbookApproval') || canAccessPage('admin')) && <NavLink to="/lookbook-approval" className={navLinkClass} onClick={closeDrawer}>Lookbook Approval</NavLink>}
          {canAccessPage('admin') && <NavLink to="/social-studio" className={navLinkClass} onClick={closeDrawer}>Social Studio</NavLink>}
          {(canAccessPage('admin') || canAccessPage('users')) && <NavLink to="/admin" className={navLinkClass} onClick={closeDrawer}>Admin</NavLink>}
        </div>
        <div className="header-right">
          {canSetupPrinter && (
            <button
              type="button"
              className={`pill-printer-btn ${qzConnected ? 'connected' : 'disconnected'}`}
              onClick={() => setIsPrinterModalOpen(true)}
              title={`Workstation Printer Setup (${qzConnected ? (qzConfig?.printers?.STICKER || 'Connected') : 'QZ Tray Not Connected'})`}
              aria-label="Workstation Printer Setup"
            >
              <span className="pill-printer-icon">🖨️</span>
              <span className={`pill-printer-dot ${qzConnected ? 'connected' : 'disconnected'}`} />
            </button>
          )}
          {!isImpersonating && <button onClick={handleLogout} className="logout-button">Logout</button>}
        </div>
      </nav>

      {canSetupPrinter && (
        <WorkstationPrinterModal
          isOpen={isPrinterModalOpen}
          onClose={() => setIsPrinterModalOpen(false)}
        />
      )}
    </>
  );
};

export default PillNavigation;
